module.exports = __webpack_public_path__ + "img/FPS@2x.9b069484.png";